'use strict';

var $ = require('jquery');

module.exports = function (options) {
	var context = options.context;

	function init() {

		context.find('[data-binding="reserve-panel"]:not(:first)').hide();
		context.find('[data-binding="reserve-tab-toggle"]:first').addClass('active');

		context.find('[data-binding="reserve-tab-toggle"]').on('click', function (e) {
			e.preventDefault();
			var href = $(this).attr('href');
			context.find('[data-binding="reserve-tab-toggle"]').removeClass('active');
			$(this).addClass('active');
			context.find('[data-binding="reserve-panel"]').hide();
			context.find(href).show();
		});
	}

	return {
		init: init
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/reserve-tabs.js
// module id = 500
// module chunks = 0